export default __webpack_public_path__ + "static/media/labs (1).d9abc6aa.JPG";